import { Stack, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import React from "react";
import Selection from "components/Input/Selection/Selection";
import { CustomComponentCommonProps } from "../utils";
import { useTranslation } from "react-i18next";

const OthersSession = ({ control, isEdit, dropdownOptions, isLoading }) => {
  const { t } = useTranslation();
  const PAGE_LOCALE_KEY = "page.merchants.";
  const FORM_LABEL_KEY = PAGE_LOCALE_KEY + "merchantDetail.info.others.fields";
  const createOptions = (list, titleKey) =>
    (list ?? []).map((item) => ({
      key: item.id,
      value: item.id,
      title: item[titleKey],
    }));
  const serviceIntegratorOptions = createOptions(
    dropdownOptions?.serviceIntegratorList,
    "company",
  );
  const referrerOptions = createOptions(
    dropdownOptions?.referrerList,
    "company",
  );
  const salesOptions = createOptions(dropdownOptions?.salesList, "firstName");
  return (
    <Stack direction={"column"} rowGap={2} width={"80%"}>
      <Stack direction={"row"} alignItems={"center"} gap={2}>
        <Typography variant="h3">
          {t(`${PAGE_LOCALE_KEY}merchantDetail.info.others.title`)}
        </Typography>
      </Stack>

      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="onboardSales"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <Selection
              errorMessage={"page.finance.refund.list.id.error.message"}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={salesOptions}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.onboardSales`),
                value,
                "Selection",
                false,
                isEdit,
                true,
              )}
            />
          )}
        />
        <Controller
          name="sales"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <Selection
              errorMessage={"page.finance.refund.list.id.error.message"}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={salesOptions}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.sales`),
                value,
                "Selection",
                false,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
      </Stack>

      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="referrer"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <Selection
              errorMessage={"page.finance.refund.list.id.error.message"}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={referrerOptions}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.referrer`),
                value,
                "Selection",
                false,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
        <Controller
          name="serviceIntegrator"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <Selection
              errorMessage={"page.finance.refund.list.id.error.message"}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              options={serviceIntegratorOptions ?? []}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.serviceIntegrator`),
                value,
                "Selection",
                false,
                isEdit,
                isLoading,
              )}
            />
          )}
        />
      </Stack>
    </Stack>
  );
};
export default React.memo(OthersSession);
